import React from "react";
import DataGrid from "../../app/grid/DataGrid";
import { IFormVersionEvaluationsPresenter } from "../../../../presenter/evaluation/FormVersionEvaluationsPresenter";
import { Spin } from "antd";
import { TGridAction } from "../../app/grid/GridActionsDropdown";

export interface Props {
  applicantId?: number;
}

export interface State extends IFormVersionEvaluationsPresenter {}

export default class EvaluationsGrid extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props) {
    super(props);
    this.state = {
      ...props
    };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { evaluations, translate } = this.state;
    const { applicantId } = this.props;

    const { formVersionEvaluationsLoader } = this.state.loaders;

    const columns = [
      {
        title: translate("applicantEvaluation_page.evaluation.date"),
        dataIndex: "date",
        key: "date"
      },
      {
        title: translate(
          "applicantEvaluation_page.evaluation.report_evaluation_status"
        ),
        dataIndex: "reportEvaluationStatus",
        key: "reportEvaluationStatus"
      },
      {
        title: translate("applicantEvaluation_page.evaluation.result"),
        dataIndex: "result",
        key: "result"
      },
      {
        title: translate("applicantEvaluation_page.evaluation.error_log"),
        dataIndex: "errorLog",
        key: "errorLog"
      }
    ];

    const actions: TGridAction[] = [
      {
        label: translate("applicantEvaluation_page.evaluation.details"),
        onClick: (record) => (e) =>
          window.open(
            `/registered-applicants/${applicantId}/details/evaluations/${record.id}`
          ),
        type: "primary"
      }
    ];

    return (
      <div>
        <Spin spinning={formVersionEvaluationsLoader || false}>
          <DataGrid
            title={translate("applicantEvaluation_page.evaluation.title")}
            translate={translate}
            columns={columns}
            dataSource={evaluations}
            actions={actions}
          />
        </Spin>
      </div>
    );
  }
}
